<template>
  <div class="container_box">
    <!--tab栏-->
    <Tabs v-model="pageParams.billType" :animated="false" class="tabs_styles" @on-click="pageParamsStatus = true">
      <TabPane v-for="item in tabList" :label="item.label" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003648')" prop="periodTime">
              <Date-picker
                type="month"
                class="wid100P"
                v-model="pageParams.periodTime"
                :clearable="true"
                format="yyyy-MM"
                placement="bottom-end"
                :placeholder="$t('key1000360')">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001579')" prop="carrierId">
              <Select v-model="pageParams.carrierId" filterable>
                <Option v-for="item in logisticsProviderData" :key="item.carrierId" :value="item.carrierId">
                  {{ item.carrierName }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" class="mr15" v-if="getPermission('ymsBill_exportLogisticsBill') ||
        getPermission('ymsBill_exportLogisticsBillDetail')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!--导入物流账单-->
      <Button class="mr15" type="primary" v-if="getPermission('ymsBill_excelLogisticsBill')"
        @click="$refs.commonImport.importModal = true">{{ $t('key1003920') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="530"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1003918')"
      paramKeyColums="logisticsBillHandlerColumn"
      :customFieldExportList="customFieldExportList"
      :dimensionTypeList="dimensionTypeList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--导入物流商账单弹窗-->
    <commonImportModal
      ref="commonImport"
      :importTitle="$t('key1003919')"
      importType="LogisticsBill"
      fileName="excelFile"
      :uploadAction="uploadZoneExcel"
      @uploadSuccess="pageParamsStatus = true"
      importTemplateKey="logisticsBill">
      {{ $t('key1002622') }}<br/>
      {{ $t('key1003921') }}<br/>
      {{ $t('key1003922') }} .xIs .xIsx .csv;<br/>
      {{ $t('key1003923') }}<br/>
      <!--4.导入操作后，请稍后在“导入/导出任务-导入查看”中查看导入结果。-->
    </commonImportModal>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :logType="['SYSTEM_LOG']"></commonLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import commonImportModal from "@/components/common/commonImportModal";
import commonLogModal from "@/components/common/commonLogModal";
import {getAllUsersInfo, getDataSetBatchList, getEnumName, getUserNameByUserId, pageJump, setConfigCharacters} from "@/utils/common";

export default {
  name: "logisticsBill",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        billType: '6',
        periodTime: null,
        carrierId: null,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          key: 'selection',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003612'),
          key: 'billNo',
          align: 'left',
          minWidth: 160,
          fixed: 'left',
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.billNo
              },
              on: {
                AlinkBtn: () => {
                  v.$router.push({
                    path: '/logisticsBillDetails',
                    query: {
                      ymsBillId: params.row.ymsBillId,
                      billType: v.pageParams.billType
                    }
                  });
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003884'),
          key: 'status',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let status = params.row.status;
            let text = getEnumName(v.enumData, 'YmsBillSettlementStatusCoreEnum', status, 'number');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613'),
          key: 'billMonth',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let date = '-';
            let billMonth = params.row.billMonth;
            if (billMonth) {
              let time = billMonth.split('-');
              date = `${time[0]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000492')}${time[1]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000493')}`;
            }
            return h('span', date);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220'),
          key: 'carrierName',
          minWidth: 230,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003915'),
          key: 'accountName',
          minWidth: 150,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003916'),
          key: 'unreconciledOrderQuantity',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let unreconciledOrderQuantity = params.row.unreconciledOrderQuantity || 0;
            let matcheQuantity = params.row.matcheQuantity || 0;
            let text = unreconciledOrderQuantity + matcheQuantity;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003917'),
          key: 'matcheQuantity',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            let unreconciledOrderQuantity = params.row.unreconciledOrderQuantity || 0;
            let matcheQuantity = params.row.matcheQuantity || 0;
            let quantity = unreconciledOrderQuantity + matcheQuantity;
            let talg = quantity === matcheQuantity && quantity !== 0 && matcheQuantity !== 0;
            return h('div', {class: 'flex align-items-center'}, [
              h('span', {class: talg ? 'greenColor' : 'crimsonRedColor'}, matcheQuantity),
              h('span', {class: 'ml4 mr4'}, ' / '),
              h('span', quantity)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003700'),
          key: 'amount',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.amount);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003701'),
          key: 'logisticsCost',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.logisticsProviderCurrency || v.currencyState;
            let text = v.formatCurrency(params.row.logisticsCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003703'),
          key: 'otherCost',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.logisticsProviderCurrency || v.currencyState;
            let text = v.formatCurrency(params.row.otherCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003704'),
          key: 'totalSuggestPrice',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let logisticsCost = params.row.logisticsCost || 0;
            let otherCost = params.row.otherCost || 0;
            let totalSuggestPrice = logisticsCost + otherCost;
            let currency = params.row.logisticsProviderCurrency || v.currencyState;
            let text = v.formatCurrency(totalSuggestPrice);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003888'),
          key: 'updatedTime',
          minWidth: 180,
          align: 'left',
          render(h, params) {
            let updatedTime = params.row.updatedTime;
            let time = updatedTime ? v.$uDate.dealTime(updatedTime, 'fulltime') : '-';
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'updatedBy',
          minWidth: 120,
          align: 'left',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'left',
          width: 200,
          fixed: 'right',
          render(h, params) {
            let ymsBillId = params.row.ymsBillId;
            let status = params.row.status;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$router.push({
                        path: '/logisticsBillDetails',
                        query: {
                          ymsBillId: ymsBillId,
                          billType: v.pageParams.billType
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002019'),
                    show: status === 1 && v.getPermission('ymsBill_confirmSettlement'),
                    clickFn: () => {
                      v.confirmSettlementBtn(ymsBillId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsBillId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      tabList: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003909'), value: '6'},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000295'), value: '4'}
      ],
      selectTableData: [],
      logisticsProviderData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003620'),
          titleKey: 'billingInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2], paramKey: 'billNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003612')},
            {type: [1, 2], paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003884')},
            {type: [1, 2], paramKey: 'periodStartTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613')},
            {type: [1, 2], paramKey: 'carrierName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220')},
            {type: [1, 2], paramKey: 'numberOfPackagesPerMonth', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003916')},
            {type: [1, 2], paramKey: 'matcheQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003917')},
            {type: [1, 2], paramKey: 'amount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003700')},
            {type: [1, 2], paramKey: 'logisticsCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003701')},
            {type: [1, 2], paramKey: 'otherCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003703')},
            {type: [1, 2], paramKey: 'totalCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003704')},
            {type: [1, 2], paramKey: 'updatedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003888')},
            {type: [1, 2], paramKey: 'updatedBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292')}
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003610'),
          titleKey: 'billDetailsInfoColums',
          selectList: [],
          checkBoxList: [
            {type: [2], paramKey: 'carrierName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220')},
            {type: [2], paramKey: 'billNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003622')},
            {type: [2], paramKey: 'ymsOrderCode', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`},
            {type: [2], paramKey: 'businessMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003173')},
            {type: [2], paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917')},
            {type: [2], paramKey: 'totalWeight', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003697')},
            {type: [2], paramKey: 'trackingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698')},
            {type: [2], paramKey: 'logisticsWeight', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003699')},
            {type: [2], paramKey: 'amount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003700')},
            {type: [2], paramKey: 'logisticsCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003701')},
            {type: [2], paramKey: 'totalCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003704')},
            {type: [2], paramKey: 'profitAndLoss', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003705')},
            {type: [2], paramKey: 'remark', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350')},
            {type: [2], paramKey: 'despatchTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003706')},
            {type: [2], paramKey: 'source', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003707')}
          ]
        }
      ],
      uploadZoneExcel: api.post_ymsBill_excelLogisticsBill,
      userInfoList: {},
      enumData: []
    };
  },
  computed: {
    dimensionTypeList() {
      let list = [
        {value: 1, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003644'), permissionKey: 'ymsBill_exportLogisticsBill'},
        {value: 2, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003645'), permissionKey: 'ymsBill_exportLogisticsBillDetail'}
      ];
      list.map((item) => {
        item['show'] = this.getPermission(item.permissionKey);
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        let enumKeyList = ['YmsBillSettlementStatusCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await getAllUsersInfo().then(data => {
          this.userInfoList = data;
        });
        await this.getBillLogisticsProviderData();
        await this.getList();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.selectTableData = [];
      v.$refs['pageParams'].resetFields();
      v.getList();
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsBillId;
        });
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.billType = Number(v.pageParams.billType);
      params.periodTime = v.pageParams.periodTime ? v.$uDate.getDateTime(v.pageParams.periodTime, 'month') : null;
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.selectTableData = [];
      v.tableData = [];
      v.total = 0;
      v.$nextTick(() => {
        v.$refs['selection'].selectAll(false);
      });
      if (v.getPermission('ymsBill_queryLogisticsBill')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsBill_queryLogisticsBill, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.updateTableDom('selection');
              v.total = data.total;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsBillIds = v.selectTableData;
      } else {
        query.ymsBillIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          let dimensionType = data.dimensionType;
          let url = dimensionType === 1 ? api.post_ymsBill_exportLogisticsBill : api.post_ymsBill_exportLogisticsBillDetail;
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 确认结算
    confirmSettlementBtn(ymsBillId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003711'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003712'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002019'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsBill_confirmSettlement + ymsBillId, null,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003713'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 获取已经生成账单的物流商数据
    getBillLogisticsProviderData() {
      let v = this;
      v.logisticsProviderData = [];
      v.axios.get(api.get_ymsBill_queryCarrier).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          v.logisticsProviderData = data;
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
  },
  components: {
    exportFieldsModal,
    commonImportModal,
    commonLogModal
  }
};
</script>

<style lang="less" scoped>

</style>
